import React from 'react';
import { Box } from '@chakra-ui/react';

interface ShimmerViewProps {
  style?: React.CSSProperties;
  children?: React.ReactNode;
  duration?: number;
  minOpacity?: number;
}

export default function ShimmerView({
  style,
  children,
  duration = 1000,
  minOpacity = 0.2,
}: ShimmerViewProps) {
  return (
    <Box
      animation="pulse"
      style={{
        ...style,
        animationDuration: `${duration}ms`,
        opacity: minOpacity,
      }}
    >
      {children}
    </Box>
  );
}
